import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import { Table, TableCell, TableContainer, TableRow, TableHead, TableBody, Box, FormControl, Button, CircularProgress } from '@mui/material';
import moment from "moment";
import useModals from 'components/modals/useModal';
import { modals } from 'components/modals/Modals'; 
import CommonExcelDownload from "components/CommonExcelDownload";
import CustomEnumSelect from "components/select/CustomEnumSelect";
import { useEnumApi } from 'contexts/EnumApiContext';
import PageInfo from "components/PageInfo";
import { useEffect } from "react";
import CustomSelect from "components/select/CustomSelect";
import { getEquipmentsByQuery } from "components/axios/equipmentAxios";
import { getEquipmentCategoriesByQuery } from "components/axios/equipmentCategoryAxios";
// import { getStationsByQuery } from "components/axios/stationAxios";
// import { getWorkingPartsByQuery } from "components/axios/workingPartAxios";
import { getDiagnosisResultVibrationByQueryString, getEquipmentPartsDiagnosisPositionsByVibrationByQuery } from "components/axios/reportAxios";
import CustomReportEquipmentPartSelect from "components/select/CustomReportEquipmentPartSelect";
import CustomDatePicker2 from "components/date_picker/CustomDatePicker2";

const IotDiagnosisVibrationReportDataroomMaintenenceReport = () => {
    const { getEnumValueByEnumName, getEnumValueByEnumNameAndCode, equipmentCategoryLevel1s } = useEnumApi();
    const { t } = useTranslation();

    // modal 관련
    const { openModal } = useModals();
    let [alertMessage, setAlertMessage] = useState('');

    const handleAlertClick = () => {
        openModal(modals.alertModal, {
            onClose : () => {
               // console.log(1111);
            },
            message: alertMessage,
        });
    };

    const regexDate = RegExp(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/);
    const [isLoading, setIsLoading] = useState(false);

    const [pageInfo, setPageInfo] = useState({});
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(50);
    const handlePaging = (value) => {
        value = isNaN(value) ? 1 : value;
        setCurrentPage(value-1);
        setIsLoading(false);
    }

    const today = dayjs(new Date()).format('YYYY-MM-DD');

    // const [workingParts, setWorkingParts] = useState([]);
    // const [stations, setStations] = useState([]);
    const [equipmentCategoryLevel2s, setEquipmentCategoryLevel2s] = useState([]);
    const [equipmentCategoryLevel3s, setEquipmentCategoryLevel3s] = useState([]);
    const [equipments, setEquipments] = useState([]);
    const [positions, setPositions] = useState([]);

    // const [subwayCode, setSubwayCode] = useState('');
    // const [workingPartId, setWorkingPartId] = useState('');
    // const [stationId, setStationId] = useState('');
    const [equipmentCategoryLevel1Id, setEquipmentCategoryLevel1Id] = useState('');
    const [equipmentCategoryLevel2Id, setEquipmentCategoryLevel2Id] = useState('');
    const [equipmentCategoryLevel3Id, setEquipmentCategoryLevel3Id] = useState('');
    const [equipmentId, setEquipmentId] = useState('');
    const [position, setPosition] = useState('');

    const [searchStartDateText, setSearchStartDateText] = useState(today);
    const [searchEndDateText, setSearchEndDateText] = useState(today);

    const [reportTitle, setReportTitle] = useState("");

    const excelTopHeaders = [t('message.common.subtitle.dateAt'), 
        // t('message.common.subtitle.subwayline'), t('message.common.subtitle.workingPart'), t('message.common.subtitle.station'), 
        t('message.common.subtitle.equipment.name'), 
        t('message.common.subtitle.equipment.number'), t('message.common.subtitle.location'), t('message.common.subtitle.axis.rms'), t('message.common.subtitle.radial.rms'), t('message.common.subtitle.vertical.rms'), 
        t('message.common.subtitle.axis.issue'), t('message.common.subtitle.radial.issue'), t('message.common.subtitle.vertical.issue'), t('message.common.subtitle.axis.iso.grade'), t('message.common.subtitle.radial.iso.grade'), t('message.common.subtitle.vertical.iso.grade'),
        t('message.common.subtitle.axis.fault.code'), t('message.common.subtitle.radial.fault.code'), t('message.common.subtitle.vertical.fault.code')];
    const [fileName, setFileName] = useState("");
    const [reports, setReports] = useState([]);
    const [excelDatas, setExcelDatas] = useState([]);

    // 호선 선택시 해당 파트 목록 가져오기
    // useEffect(()=>{
    //     if (subwayCode) {
    //         const param = {"subwayLine" : subwayCode, size:50}
    //         getWorkingPartsByQuery(param).then((data)=>{
    //             if (data && data._embedded) {
    //                 let workingParts = data._embedded.workingParts;
    //                 setWorkingParts(workingParts);
    //             } else {
    //                 setWorkingParts([]);
    //             }
    //             setStations([]);
    //         });
    //     }
    // },[subwayCode]);

    // // 파트 선택시 해당 역사 목록 가져오기
    // useEffect(()=>{
    //     if (workingPartId) {
    //         const param = {"workingPart.id" : workingPartId, sort:"code,asc", size:50};
    //         getStationsByQuery(param).then((data)=>{
    //             if (data && data._embedded) {
    //                 setStations(data._embedded.stations);
    //             } else {
    //                 setStations([]);
    //             }
    //         });
    //     }
    // },[workingPartId]);

    // 설비중분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel1Id) {
            const param = { "parent.id": equipmentCategoryLevel1Id, depth: 2, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipmentCategories;
                    if (list) {
                        setEquipmentCategoryLevel2s(list);
                    } else {
                        setEquipmentCategoryLevel2s([]);
                    }
                } else {
                    setEquipmentCategoryLevel2s([]);
                }
                setEquipmentCategoryLevel3s([]);
            });
        }
    },[equipmentCategoryLevel1Id]);

    // 설비분류 목록
    useEffect(()=>{
        if (equipmentCategoryLevel2Id) {
            const param = { "parent.id": equipmentCategoryLevel2Id, depth: 3, size : 100, sort : "name,asc" };
            getEquipmentCategoriesByQuery(param).then((data) => {
                if (data && data._embedded) {
                const list = data._embedded.equipmentCategories;
                    if (list) {
                        setEquipmentCategoryLevel3s(list);
                    } else {
                        setEquipmentCategoryLevel3s([]);
                    }
                } else {
                    setEquipmentCategoryLevel3s([]);
                }
            });
        }
    },[equipmentCategoryLevel2Id]);

    // 설비목록 
    useEffect(()=>{
        // if (subwayCode && workingPartId && stationId && equipmentCategoryLevel1Id && equipmentCategoryLevel2Id && equipmentCategoryLevel3Id) {
        if (equipmentCategoryLevel1Id && equipmentCategoryLevel2Id && equipmentCategoryLevel3Id) {
            const param = { 
            //   "station.workingPart.subwayLine" : subwayCode,
            //   "station.workingPart.id" : workingPartId,
            //   "station.id" : stationId,
              "equipmentCtgr.parent.parent.id" : equipmentCategoryLevel1Id,
              "equipmentCtgr.parent.id" : equipmentCategoryLevel2Id,
              "equipmentCtgr.id" : equipmentCategoryLevel3Id,
              size : 200
            };
            getEquipmentsByQuery(param).then((data) => {
                if (data && data._embedded) {
                    const list = data._embedded.equipments;
                    if (list) {
                      setEquipments(list);
                    } else {
                      setEquipments([]);
                    }
                } else {
                  setEquipments([]);
                }
            });
        }
    // },[subwayCode, workingPartId, stationId, equipmentCategoryLevel1Id, equipmentCategoryLevel2Id, equipmentCategoryLevel3Id]);
    },[equipmentCategoryLevel1Id, equipmentCategoryLevel2Id, equipmentCategoryLevel3Id]);

    // 설비에 등록된 진단위치목록
    useEffect(()=>{
        if (equipmentId) {
            // const param = { "equipment.id": equipmentId, deletedYn:false, "sensors.sensorType":'V', size:100};
            // const param = { "equipment.id": equipmentId, deletedYn:false, size:100};
            getEquipmentPartsDiagnosisPositionsByVibrationByQuery(equipmentId).then((data) => {
                if (data) {
                    setPositions(data);
                } else {
                    setPositions([]);
                }
            });
        }
    },[equipmentId]);

    const selectParam = () => {
        if (searchStartDateText === null || searchStartDateText === '' || searchEndDateText === null || searchEndDateText === '') {
            alertMessage = t('message.common.alert.period.select');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (searchStartDateText === null || searchStartDateText === '' || !regexDate.test(searchStartDateText)) {
            alertMessage = t('message.common.alert.date.exactly.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        if (searchEndDateText === null || searchEndDateText === '' || !regexDate.test(searchEndDateText)) {
            alertMessage = t('message.common.alert.date.exactly.input');
            setAlertMessage(alertMessage);
            handleAlertClick();
            return;
        }

        setCurrentPage(0);
        pageInfo.number = 0;
        setPageInfo(pageInfo);
        reportList(0);
        setExcelDatas([]);
    }

    useEffect(()=> {
        if (!isLoading && !isNaN(currentPage) && searchStartDateText != null && searchStartDateText != '' && searchEndDateText != null && searchEndDateText != '') {
            reportList();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage, isLoading]);

    function reportList(curPage=currentPage) {
        isNaN(curPage) && setCurrentPage(0);
        isNaN(pageSize) && setPageSize(50);
        let param = {
            page: curPage,
            size : pageSize,
        };

        // if (subwayCode) {
        //     param['equipment.station.workingPart.subwayLine'] = subwayCode;
        // }
        // if (workingPartId) {
        //     param['equipment.station.workingPart.id'] = workingPartId;
        // }
        // if (stationId) {
        //     param['equipment.station.id'] = stationId;
        // }
        if (equipmentCategoryLevel1Id) {
            param['equipment.equipmentCtgr.parent.parent.id'] = equipmentCategoryLevel1Id;
        }
        if (equipmentCategoryLevel2Id) {
            param['equipment.equipmentCtgr.parent.id'] = equipmentCategoryLevel2Id;
        }
        if (equipmentCategoryLevel3Id) {
            param['equipment.equipmentCtgr.id'] = equipmentCategoryLevel3Id;
        }
        if (equipmentId) {
            param['equipment.id'] = equipmentId;
        }
        if (position) {
            param['equipmentPart.id'] = position;
        }

        let addQueryString = "";
        if (searchStartDateText && searchEndDateText) {
            let startDay = new Date(searchStartDateText);
            addQueryString += "&analysisAt=gte(" + encodeURIComponent(moment(new Date(startDay.getFullYear(), startDay.getMonth(), startDay.getDate(), 0, 0, 0)).format());
            let endDay = new Date(searchEndDateText);
            addQueryString += ")&analysisAt=and(lte(" + encodeURIComponent(moment(new Date(endDay.getFullYear(), endDay.getMonth(), endDay.getDate(), 23, 59, 59)).format()) + "))";
        }
        
        let queryString = Object.entries(param).map(([key, value]) => (value && key + '=' + value)).filter(v => v).join('&');
        queryString += addQueryString;

        let reportTitle = t('message.common.title.iot.diagnosis.report.vibration')+"(";
        reportTitle += searchStartDateText;
        reportTitle += " ~ ";
        reportTitle += searchEndDateText;
        reportTitle += ")";
        setReportTitle(reportTitle);
        setFileName(reportTitle+"_"+Date.now());

        Promise.all([
            getDiagnosisResultVibrationByQueryString("?" + queryString).then((data) => {
                if (data != null) {
                    if (data.page) {
                        setPageInfo(data.page);
                    } else {
                        setCurrentPage(0);
                        pageInfo = {
                            size: pageInfo.size,
                            totalElements: 0,
                            totalPages: 0,
                            number: 0
                        };
                        setPageInfo(pageInfo);
                    }
                    if (data._embedded) {
                        let list = data._embedded.diagnosisResultVibrations;
                        if (list) {
                            let excelDatas = [];
                            let excelData = [];
                            list && list.forEach(function (column, a) {
                                excelData = [
                                    ((column.analysisAt && dayjs(column.analysisAt).format('YYYY-MM-DD HH:mm')) || ''),
                                    // ((column.equipment.station && getEnumValueByEnumNameAndCode("SubwayLine", column.equipment.station.workingPart.subwayLine)[0].title) || ''),
                                    // ((column.equipment.station && column.equipment.station.workingPart.name) || ''),
                                    // ((column.equipment.station && column.equipment.station.name) || ''),
                                    ((column.equipment && column.equipment.name) || ''),
                                    ((column.equipment && column.equipment.equipmentNo) || ''),
                                    ((column.equipmentPart && (column.equipmentPart.position + "-" + column.equipmentPart.masterEquipmentPart.name)) || ''),
                                    ((column.overallShaft.toFixed(2)) || ''),
                                    ((column.overallHorizon.toFixed(2)) || ''),
                                    ((column.overallVertical.toFixed(2)) || ''),
                                    ((column.abnormalCheckShaft) || ''),
                                    ((column.abnormalCheckHorizon) || ''),
                                    ((column.abnormalCheckVertical) || ''),
                                    (column.rankShaft || ''),
                                    (column.rankHorizon || ''),
                                    (column.rankVertical || ''),
                                    ((column.shaftDiagnosisCodes && column.shaftDiagnosisCodes.length > 0 && column.shaftDiagnosisCodes[0].subCategoryNm) || ''),
                                    ((column.horizonDiagnosisCodes && column.horizonDiagnosisCodes.length > 0 && column.horizonDiagnosisCodes[0].subCategoryNm) || ''),
                                    ((column.verticalDiagnosisCodes && column.verticalDiagnosisCodes.length > 0 && column.verticalDiagnosisCodes[0].subCategoryNm) || '')
                                ];
                                excelDatas.push(excelData);
                            });
                            setReports(excelDatas);
                            return data.page.totalElements;
                        } else {
                            setReports([]);
                            return 0;
                        }
                    } else {
                        setReports([]);
                        return 0;
                    }
                }
            })
        ]).then((res)=>{
            setIsLoading(true);
            delete param.page;
            param.page = 0;
            const totalCount = res[0];
            if (totalCount > 0) {
                param.size = totalCount;
                queryString = Object.entries(param).map(([key, value]) => (value && key + '=' + value)).filter(v => v).join('&');
                queryString += addQueryString;
                getDiagnosisResultVibrationByQueryString("?" + queryString).then((data) => {
                    if (data && data._embedded) {
                        let list = data._embedded.diagnosisResultVibrations;
                        if (list) {
                            let excelDatas = [];
                            let excelData = [];
                            list && list.forEach(function (column, a) {
                                excelData = [
                                    ((column.analysisAt && dayjs(column.analysisAt).format('YYYY-MM-DD HH:mm')) || ''),
                                    // ((column.equipment.station && getEnumValueByEnumNameAndCode("SubwayLine", column.equipment.station.workingPart.subwayLine)[0].title) || ''),
                                    // ((column.equipment.station && column.equipment.station.workingPart.name) || ''),
                                    // ((column.equipment.station && column.equipment.station.name) || ''),
                                    ((column.equipment && column.equipment.name) || ''),
                                    ((column.equipment && column.equipment.equipmentNo) || ''),
                                    ((column.equipmentPart && (column.equipmentPart.position + "-" + column.equipmentPart.masterEquipmentPart.name)) || ''),
                                    ((column.overallShaft.toFixed(2)) || ''),
                                    ((column.overallHorizon.toFixed(2)) || ''),
                                    ((column.overallVertical.toFixed(2)) || ''),
                                    ((column.abnormalCheckShaft) || ''),
                                    ((column.abnormalCheckHorizon) || ''),
                                    ((column.abnormalCheckVertical) || ''),
                                    (column.rankShaft || ''),
                                    (column.rankHorizon || ''),
                                    (column.rankVertical || ''),
                                    ((column.shaftDiagnosisCodes && column.shaftDiagnosisCodes.length > 0 && column.shaftDiagnosisCodes[0].subCategoryNm) || ''),
                                    ((column.horizonDiagnosisCodes && column.horizonDiagnosisCodes.length > 0 && column.horizonDiagnosisCodes[0].subCategoryNm) || ''),
                                    ((column.verticalDiagnosisCodes && column.verticalDiagnosisCodes.length > 0 && column.verticalDiagnosisCodes[0].subCategoryNm) || '')
                                ];
                                excelDatas.push(excelData);
                            });
                            setExcelDatas(excelDatas);
                        } else {
                            setExcelDatas([]);
                        }
                    } else {
                        setExcelDatas([]);
                    }
                })
            } else {
                setExcelDatas([]);
            }
        })
    }

    return (
        <div style={{color:"#000"}}>
            <Box sx={{ minWidth: 120 }}>
                {/* {getEnumValueByEnumName("SubwayLine") && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomEnumSelect
                        key={subwayCode}
                        label={t('message.common.subtitle.subwayline')}
                        labelName={t('message.common.subtitle.subwayline')}
                        name={'subway'}
                        defaultValue={subwayCode}
                        onChange={(e)=>{
                            setSubwayCode(e.target.value);
                            setWorkingPartId('');
                            setStationId('');
                            setEquipmentId('');
                            setEquipments([]);
                            setPosition('');
                            setPositions([]);
                        }}
                        list={getEnumValueByEnumName("SubwayLine")}
                    />
                </FormControl>
                }
                {workingParts && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                <CustomSelect
                    key={workingPartId}
                    label={t('message.common.subtitle.workingPart')}
                    labelName={t('message.common.subtitle.workingPart')}
                    name={'workPart'}
                    defaultValue={workingPartId}
                    onChange={(e)=>{
                        setWorkingPartId(e.target.value);
                        setStationId('');
                        setEquipmentId('');
                        setEquipments([]);
                        setPosition('');
                        setPositions([]);
                    }}
                    list={workingParts}
                />
                </FormControl>
                }
                {stations && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                <CustomSelect
                    key={stationId}
                    label={t('message.common.subtitle.station')}
                    labelName={t('message.common.subtitle.station')}
                    name={'station'}
                    defaultValue={stationId}
                    onChange={(e)=>{
                        setStationId(e.target.value);
                        setPosition('');
                        setPositions([]);
                    }}
                    list={stations}
                />
                </FormControl>
                } */}
                {equipmentCategoryLevel1s && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                        key={equipmentCategoryLevel1Id}
                        label={t('message.common.subtitle.equipment.level1')}
                        labelName={t('message.common.subtitle.equipment.level1')}
                        name={'level1'}
                        defaultValue={equipmentCategoryLevel1Id}
                        onChange={(e)=>{
                            setEquipmentCategoryLevel1Id(e.target.value);
                            setEquipmentCategoryLevel2Id('');
                            setEquipmentCategoryLevel3Id('');
                            setEquipmentId('');
                            setEquipments([]);
                            setPosition('');
                            setPositions([]);
                        }}
                        list={equipmentCategoryLevel1s}
                    />
                </FormControl>
                }
                {equipmentCategoryLevel2s && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                        key={equipmentCategoryLevel2Id}
                        label={t('message.common.subtitle.equipment.level2')}
                        labelName={t('message.common.subtitle.equipment.level2')}
                        name={'level2'}
                        defaultValue={equipmentCategoryLevel2Id}
                        onChange={(e)=>{
                            setEquipmentCategoryLevel2Id(e.target.value);
                            setEquipmentCategoryLevel3Id('');
                            setEquipmentId('');
                            setEquipments([]);
                            setPosition('');
                            setPositions([]);
                        }}
                        list={equipmentCategoryLevel2s}
                    />
                </FormControl>
                }
                {equipmentCategoryLevel3s && 
                <FormControl sx={{ m: 1, minWidth: 80 }}>
                    <CustomSelect
                        key={equipmentCategoryLevel3Id}
                        label={t('message.common.subtitle.equipment.level3')}
                        labelName={t('message.common.subtitle.equipment.level3')}
                        name={'level3'}
                        defaultValue={equipmentCategoryLevel3Id}
                        onChange={(e)=>{
                            setEquipmentCategoryLevel3Id(e.target.value);
                            setPosition('');
                            setPositions([]);
                            setEquipmentId('');
                            setEquipments([]);
                        }}
                        list={equipmentCategoryLevel3s}
                    />
                </FormControl>
                }
                {equipments && 
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <CustomSelect
                        key={equipmentId}
                        label={t('message.common.btn.equipment')}
                        labelName={t('message.common.btn.equipment')}
                        name={'equipment'}
                        defaultValue={equipmentId}
                        onChange={(e)=>{
                            setEquipmentId(e.target.value);
                            setPosition('');
                            setPositions([]);
                        }}
                        list={equipments}
                    />
                </FormControl>
                }
                {positions && 
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <CustomReportEquipmentPartSelect
                        key={position}
                        label={t('message.common.subtitle.diagnosis.location')}
                        labelName={t('message.common.subtitle.diagnosis.location')}
                        name={'position'}
                        defaultValue={position}
                        onChange={(e)=>{
                            setPosition(e.target.value);
                        }}
                        list={positions}
                    />
                </FormControl>
                }
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <CustomDatePicker2 
                        name={"searchStartDateText"} 
                        value={searchStartDateText} 
                        onChange={(e)=>{setSearchStartDateText(e.target.value)}}
                        className='search_22'
                    />
                </FormControl>
                ~
                <FormControl sx={{ m: 1, minWidth: 120 }}>
                    <CustomDatePicker2 
                        name={"searchEndDateText"} 
                        value={searchEndDateText} 
                        onChange={(e)=>{setSearchEndDateText(e.target.value)}}
                        className='search_22'
                    />
                </FormControl>

                <Link to={''}><Button variant="contained" style={{marginTop:"13px",padding:"5px 15px"}} onClick={selectParam}>{t('message.common.btn.report.generation')}</Button></Link>
            </Box>

            {reportTitle &&
            <div>
                <p className="report-dataroom-tit">
                    {reportTitle}
                </p>

                <div className="scrollbar">
                    <TableContainer>
                        <Table sx={{ minWidth: 1000, borderTop:"2px solid #9b9b9b" }} aria-label="simple table" className="list_table fix_table">
                            <TableHead>
                                <TableRow>
                                    {excelTopHeaders && excelTopHeaders.map((header,i)=> {
                                        return (
                                    <TableCell key={i}>{header}</TableCell>    
                                    )
                                    })}
                                </TableRow>
                            </TableHead>

                            <TableBody>
                            { reports && reports.map(function(items, i) {
                                return (
                                <TableRow key={i}>
                                {items && items.map((item, j)=> {
                                    return (
                                    <TableCell key={j}>{item}</TableCell>
                                    )
                                })}
                                </TableRow>
                                )
                            })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                <br/>

                {(excelDatas && excelDatas.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page'>
                        <CommonExcelDownload excelDatas={excelDatas} excelHeader={excelTopHeaders} title={`${reportTitle}`} filename={`${fileName}.xlsx`} />
                    </div>
                </div>
                :
                (reports && reports.length > 0) ?
                <div className="report-dataroom-button">
                    <div></div>
                    <div className='no-print-page' style={{color:"#000"}}>
                        <Box sx={{ display: 'flex', color:"#000" }}>
                            {t('message.common.text.excel.downloading')}<CircularProgress size="1rem" />
                        </Box>
                    </div>
                </div>
                : ''
                }

                <PageInfo pageInfo={pageInfo} handlePaging={handlePaging}/>

            </div>
            }
        </div>
    )

}

export default IotDiagnosisVibrationReportDataroomMaintenenceReport;